export const knownIssues = [
  'Some achievements titles/icons are missing',
  'One of the bear legs is misplaced',
];
